export const SoundStatus = {
  on: 'on',
  off: 'off',
} as const;
export type SoundStatus = (typeof SoundStatus)[keyof typeof SoundStatus];

export type MultiSoundStatusMap = {
  [key: string]: SoundStatus;
};
